// import { AUTH_BASE_URL } from "../../../constants";
// import { getAppToken } from "../../../store/actions/auth";
import { AUTH_BASE_URL } from "../../../constants";
import { AuthConfig } from "../../../context/config/authConfig";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import {
  IRequestOtpResponse,
  IValidateOtpRequestBody,
  IValidateOtpResponse,
} from "./models";

const appProvide = async () => AuthConfig.getAppToken();

export const requestOtp = (userId: string): Promise<IRequestOtpResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/users/${userId}/otps`,
    "POST",
    appProvide
  );
  return fetchRequest(descriptor, null);
};

export type RequestOtpBody = {
  userId?: string;
  phoneNumber?: string;
  notificationChannel: "SMS" | "WHATSAPP";
};

export const requestOtp2 = (
  body: RequestOtpBody
): Promise<IRequestOtpResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/otps/generate`,
    "POST",
    appProvide
  );
  return fetchRequest(descriptor, body);
};

export const validateOtp = (
  userId: string,
  body: IValidateOtpRequestBody
): Promise<IValidateOtpResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/users/${userId}/otps/validate`,
    "POST",
    appProvide
  );
  return fetchRequest(descriptor, body);
};

export const validateOtpGeneric = (
  body: IValidateOtpRequestBody
): Promise<IValidateOtpResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/otps/validate`,
    "POST",
    appProvide
  );
  return fetchRequest(descriptor, body);
};
